

import { getPublicKey } from '@/apis/user'
import JSEncrypt from "jsencrypt";
// 密码加密
export const encryptPwd = async (pwd) => {
  const res = await getPublicKey()

  // 使用公钥加密数据
  var encrypt = new JSEncrypt();
  encrypt.setPublicKey(res);

  return encrypt.encrypt(pwd);
}